import { useState, useCallback } from 'react';

export type PWN201Mode = 'browse' | 'add' | 'edit';

export function usePWN201Mode() {
  const [mode, setMode] = useState<PWN201Mode>('browse');

  const isEditing = mode === 'add' || mode === 'edit';

  const enterAdd = useCallback(() => setMode('add'), []);
  const enterEdit = useCallback(() => setMode('edit'), []);
  const exitEdit = useCallback(() => setMode('browse'), []);

  return { mode, setMode, isEditing, enterAdd, enterEdit, exitEdit };
}
